import { styled } from "@mui/material/styles";
import { green } from "@mui/material/colors";

const Container = styled("div")(({ theme }) => ({
  textAlign: "center",
  color: "black",
}));
const ContentDialog = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  padding: "15px",
}));
const BoxDialog = styled("div")(({ theme }) => ({
  display: "flex",
  m: "auto",
  position: "relative",
}));
const CircularProgressCSS = {
  color: green[500],
  position: "absolute",
  top: -6,
  left: -6,
  zIndex: 1,
};
const ButtonSx = {
  bgcolor: "#FF0000",
  "&:hover": {
    bgcolor: "#FF0000",
  },
};

export { Container, ContentDialog, BoxDialog, CircularProgressCSS, ButtonSx };
